import React, { ReactElement } from 'react'
import { Title, Button } from '../../importCL';
import { transformHTMLParserLinks } from '../../utils/rewriteLink/rewriteLink';
import './AddressSuggestionPopup.css';

interface IAddressSuggestionPopup {
	headline?: string;
	subHeadline?: string;
	acceptCtaText?: string;
	declineCtaText?: string;
	acceptCtaCallback?: () => void;
	declineCtaCallback?: () => void;
	suggestedAddress?: {
		addressLine1: string;
		addressLine2?: string;
		city: string;
		state: string;
		zipCode: string;
	};
}

function AddressSuggestionPopup({ headline, subHeadline, acceptCtaText, declineCtaText, acceptCtaCallback, declineCtaCallback, suggestedAddress }: IAddressSuggestionPopup) {

	const formatSuggestedAddress = (): string => {
		if (!suggestedAddress) {
			return '';
		}

		const addressLine = suggestedAddress.addressLine2 === undefined ? suggestedAddress.addressLine1 : `${suggestedAddress.addressLine1} ${suggestedAddress.addressLine2}`
		return `${addressLine}, ${suggestedAddress.city} ${suggestedAddress.state} ${suggestedAddress.zipCode}`
	}

	return (
		<div className='AddressSuggestionPopup__popUpContainer'>
			<div className='AddressSuggestionPopup__popUpContent'>
				<Title className='AddressSuggestionPopup__popUpClose' onClick={declineCtaCallback}>×</Title>
				<Title className='AddressSuggestionPopup__popUpHeadline' tag='h5' >
					{transformHTMLParserLinks(headline)}
				</Title>
				<p className='AddressSuggestionPopup__popUpSubHeadline'>
					{transformHTMLParserLinks(subHeadline)}
				</p>
				<p id="formattedAddress" className='AddressSuggestionPopup__popUpSubHeadline'>
					{formatSuggestedAddress()}
				</p>
				<div className='AddressSuggestionPopup__popUpButtons'>
					{/* TODO: remove the cast as unknown as ReactElement when CL is updated to use ReactNode instead of ReactElement */}
					<Button className='AddressSuggestionPopup__popUpButton' onClick={acceptCtaCallback} size='small' target='_self' variant='solid'>{transformHTMLParserLinks(acceptCtaText) as unknown as ReactElement}</Button>
					<Button className='AddressSuggestionPopup__popUpButton' onClick={declineCtaCallback} size='small' target='_self' variant='ghosted-dark'>{transformHTMLParserLinks(declineCtaText) as unknown as ReactElement}</Button>
				</div>
			</div>
		</div>

	)
}

export default AddressSuggestionPopup;